<div class="divLoading" *ngIf="loading" >
    <div style="height: 100%; width: 100%; display: flex;justify-content: center;">
        <img  *ngIf="!template.getSite().logoloading" [src]="template.getSite().url_logo" alt="" style="border-radius: 10px !important;">
        <img *ngIf="template.getSite().logoloading" [src]="template.getSite().logoloading" alt="" style="border-radius: 10px !important;">
    </div>
</div>